import { Record } from 'immutable';
import ConfigEndpointModel from 'commons-configs/models/ConfigEndpointModel.js';
import ConfigSourceModel from 'commons-configs/models/ConfigSourceModel.js';
import ConfigSentryModel from 'commons-configs/models/ConfigSentryModel.js';

const ConfigsRecord = Record({
    endpoint: new ConfigEndpointModel(),
    source: new ConfigSourceModel(),
    secureCookies: null,
    sentry: new ConfigSentryModel(),
});

class ConfigsModel extends ConfigsRecord {
    constructor(props = new ConfigsRecord(null)) {
        const newConfigs = super(props);
        return newConfigs
            .set('secureCookies', props.secureCookies === 'true' || props.secureCookies === true)
            .set('endpoint', new ConfigEndpointModel(props.endpoint))
            .set('source', new ConfigSourceModel(props.source))
            .set('sentry', new ConfigSentryModel(props.sentry));
    }
}

export default ConfigsModel;
